import repository from '../../repositories/crm/crm.status.repository';

const findBySellerId = (sellerId) =>
    repository
        .findBySellerId(sellerId)
        .then(res => res.data || []);

export default {
    findBySellerId
}